import type { UnitEmblem } from '../../shared/game/world-types.js';

/**
 * A gang is told by its symbol: every bandit wearing the same mark belongs to the same gang. The Ember Coast's bandits are all the Black
 * Hood, an outlaw order whose mark is the executioner's hood. Another gang would be another glyph (`src/content/emblems/glyphs.ts`) and
 * its own `UnitEmblem`, passed to `bandit()` in its crews' place.
 */
/** The hood's colour: an ash-toned off white, well short of stark, that still shows on dark leather, mail and cloth. */
export const HOOD_INK = 0xb9b3a2;

/** A bare mark (no field behind it, no bars beneath) of one glyph in one ink. */
export function gangSymbol(glyph: string, ink: number): UnitEmblem {
  return { glyph, ink, field: 'none', fieldColor: 0, ticks: 0 };
}

/** The Black Hood's mark. */
export const BLACK_HOOD: UnitEmblem = gangSymbol('executioner-hood', HOOD_INK);
